// Catalog data source.
//
// In WordPress the theme bootstraps `window.AP_DATA` via `wp_localize_script`
// before this file runs. The shape is:
//
//   { brands: [], bodies: [], fuels: [], listings: [], apiBase, nonce, … }
//
// All listings come from the REST endpoint `apiBase + 'listings'` - they are
// NOT bundled into the page payload. `brands`, `bodies`, `fuels` are the
// filter facets (with counts of for-sale cars).
//
// In the phase-1 static demo there is no server-side hydration; AP_DATA stays
// empty and the modules degrade to empty states.

const EMPTY = {
  brands: [],
  bodies: [],
  fuels: [],
  listings: [],
  apiBase: '',
  nonce: '',
  catalog: '/cars/',
};

export const AP_DATA = (typeof window !== 'undefined' && window.AP_DATA)
  ? Object.assign({}, EMPTY, window.AP_DATA)
  : EMPTY;

if (typeof window !== 'undefined') window.AP_DATA = AP_DATA;
